module.exports = __webpack_public_path__ + "static/img/video_log.8133fdf7.jpg";